import { Form, useFormikContext } from 'formik';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import * as Yup from 'yup';
import { makeStyles } from 'tss-react/mui';
import RadioGroupField from '../forms/radio-group-field';
import FormSubmitStatus from '../forms/form-submit-status';

const useStyles = makeStyles()((theme) => ({
  submitButtons: {
    margin: theme.spacing(2, 0)
  },
}));

export const formSchema = Yup.object().shape({
  weeklyEventsReminder: Yup.string().oneOf(['ALL', 'NONE']).required(),
  weekendEventsReminder: Yup.string().oneOf(['ALL', 'NONE']).required(),
  emailMarketingPreference: Yup.string().oneOf(['ALL', 'NONE']).required('Email marketing preference is required.'),
});

type Props = {
  disabled?: boolean;
};

const AccountNotificationsForm = ({ disabled: formDisabled }: Props) => {
  const { isSubmitting } = useFormikContext();
  const { classes } = useStyles();
  const disabled = formDisabled || isSubmitting;
  return (
    <Form>
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h3">Weekly Digests</Typography>
        <RadioGroupField
          name="weeklyEventsReminder"
          label="Weekly Events Digest (sent once a week on Sunday afternoons)"
          disabled={disabled}
          options={[
            {
              label: 'On (one weekly email)',
              value: 'ALL',
            },
            {
              label: 'Off',
              value: 'NONE',
            },
          ]}
        />
        <RadioGroupField
          name="weekendEventsReminder"
          label="Weekend Events Digest (sent once a week on Friday mornings)"
          disabled={disabled}
          options={[
            {
              label: 'On (one weekly email)',
              value: 'ALL',
            },
            {
              label: 'Off',
              value: 'NONE',
            },
          ]}
        />
      </Paper>

      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h3">Everyday Rides Updates</Typography>
        <RadioGroupField
          name="emailMarketingPreference"
          label="Occasionally, Everyday Rides would like to communicate with you via email. You can unsubscribe at any time."
          disabled={disabled}
          options={[
            {
              label: 'Yes, allow Everyday Rides to send me occasional email about new features and updates',
              value: 'ALL',
            },
            {
              label: 'No, don\'t send me any email about new features and updates',
              value: 'NONE',
            },
          ]}
        />
      </Paper>

      <div className={classes.submitButtons}>
        <Button
          type="submit"
          sx={{ mt: 2 }}
          disabled={disabled}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
        <FormSubmitStatus />
      </div>
    </Form>
  );
};

export default AccountNotificationsForm;
